var map = {
	"./alarms.svg": 7690,
	"./batch_set.svg": 8576,
	"./desktop.svg": 4110,
	"./device.svg": 5148,
	"./fees.svg": 8818,
	"./fullscreen-exit.svg": 7294,
	"./fullscreen.svg": 6286,
	"./global.svg": 9188,
	"./incoming.svg": 1015,
	"./manual.svg": 4641,
	"./order.svg": 3207,
	"./pay-log.svg": 5100,
	"./phone.svg": 5522,
	"./protocol.svg": 8619,
	"./recharge.svg": 9416,
	"./relocation.svg": 3073,
	"./scan.svg": 2833,
	"./sound.svg": 2665
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;